'use strict';

var shippingAddressOne = '#shippingAddressOneLoqate';
var dropdownAddressSuggestions = '.dropdown-address-suggestions';

/**
 * Remove Values on the address suggestions dropdown
 */
function removeAddressSuggestions() {
    $(dropdownAddressSuggestions)
        .hide()
        .removeAttr('data-showdropdownaddresssuggestions')
        .find('.search-result')
        .removeClass('search-right-animation')
        .empty();
}

/**
 * Show additional shipping address fields
 */
function showAdditionalAddressFields() {
    $('.additional-address-fields').removeClass('d-none');
}

/**
 * Updates a flag to show if the form has been changed since the autocomplete
 * @param {boolean} changed - has the form been updated
*/
function updateNeedsVerification(changed) {
    $(shippingAddressOne).attr('data-address-needs-verification', changed);
}

/**
 * Checks to see if the shipping form has been changed
 * from the auto complete values
 * @param {Array} addressFormFields - array of form fields
 * @returns {string} return if any address field has been updated
*/
function checkForShippingsAddressChanges(addressFormFields) {
    var isChanged = false;
    addressFormFields.each(function () {
        if ($(this).val() !== $(this).data('suggestion')) {
            isChanged = true;
        }
    });
    return isChanged;
}

/**
 * Return string with bold tag if typed string matched
 * @param {string} displayAddress - addresses text
 * @param {string} highlightIndex - text to be searched for address
 * @returns {string} return address with  strong tag
 */
function highlightTypedText(displayAddress, highlightIndex) {
    var highlightPairs = highlightIndex.split(',').map(function (item) {
        return item.split('-');
    });
    // Create a new string with the highlighted text
    var highlightedText = '';
    var currentIndex = 0;
    highlightPairs.forEach(function (pair) {
        var startIndex = parseInt(pair[0], 10);
        var endIndex = parseInt(pair[1], 10);
        highlightedText += displayAddress.slice(currentIndex, startIndex);
        highlightedText += `<strong>${displayAddress.slice(startIndex, endIndex)}</strong>`;
        currentIndex = endIndex;
    });
    highlightedText += displayAddress.slice(currentIndex);
    return highlightedText;
}
/**
 * Remove hash symbols from an address string.
 * @param {string} displayAddress - addresses text
 * @returns {string} The address without hash symbols.
 */
function removeHashFromAddress(displayAddress) {
    return displayAddress ? displayAddress.split('#').join('') : displayAddress;
}

/**
 * Generated HTML of addresses for dropdown
 * @param {Array} addresses - List of address objects returned from Loqate API
 * @returns {string} An HTML formatted string containing the list of suggested addresses.
 */
function generateAddressSuggestionList(addresses) {
    var suggestionItems = addresses.map(function (address) {
        var displayAddress = address.Text;
        var listItem = null;
        var displayAddressContainer = address && address.Highlight ? highlightTypedText(displayAddress, address.Highlight) : displayAddress;
        if (address.Type === 'Address') {
            listItem = `
            <li class="dropdown-item" role="listitem" data-address="${displayAddress}" data-hash-address="${removeHashFromAddress(displayAddress)}" data-id=${address.Id}>
                <div aria-label="${displayAddress}">${displayAddressContainer}</div>
            </li>
        `;
        } else if (address.Type === 'Container') {
            listItem = `
            <li class="dropdown-item loqate-address-container d-flex justify-content-between align-items-center" role="listitem" data-address="${displayAddress}" data-hash-address="${removeHashFromAddress(displayAddress)}" data-id=${address.Id}>
                <div aria-label="${displayAddress}" class="loqate-container-text">${displayAddressContainer}</div>
                <svg role="img" class="icon svg-icon loqate-container-img" aria-hidden="true" width="15" height="15" aria-labelledby="title desc">
                    <use xlink:href="#right-icon"></use>
                </svg>
            </li>
        `;
        }
        return listItem;
    });
    return `<ul class="search-inner">${suggestionItems.join('')}</ul>`;
}

/**
 * turn off locate when we want to use a manual address
 * by removing the keydown event on #shippingAddressOneLoqate
 */
function handleManualAddress() {
    $(shippingAddressOne).attr('autocomplete', 'off').off('keydown');
    removeAddressSuggestions();
    showAdditionalAddressFields();
    $(shippingAddressOne)[0].focus();
}

/**
 * initialize the events associated with the
 * manual address link
*/
function initEnterManualAddressEvents() {
    if ($(shippingAddressOne) && $(shippingAddressOne).val() && $(shippingAddressOne).val().length > 0) {
        handleManualAddress();
        updateNeedsVerification(true);
    }

    $(document).on('click', '#enterAddressManually', function (event) {
        event.stopPropagation();
        handleManualAddress();
        updateNeedsVerification(true);
        $(document).trigger('loqate:enter-manual-address'); // tracking
    });
}

/**
 * Utility function for checking if the provided list item is a loqate container.
 * @param {Object} listItem A jquery selection of a list item.
 * @returns {boolean} True if the given item is a container and false otherwise.
 */
function isLoqateContainer(listItem) {
    return listItem && listItem.hasClass('loqate-address-container');
}

/**
 * Determine if the dropdown is showing suggested addresses for a
 * specific loqate container.
 * @returns {boolean} True if the dropdown is showing addresses within a loqate
 * container and false otherwise.
 */
function isContainerMode() {
    return $('.search-result').attr('data-suggestion-mode') === 'container';
}

/**
 * Utility function to determine if the dropdown menu is open (visible)
 * @returns {boolean} True if the dropdown menu is open (visible) and false
 * otherwise.
 */
function isDropdownMenuOpen() {
    return $(dropdownAddressSuggestions).is(':visible') || $(dropdownAddressSuggestions).attr('data-showdropdownaddresssuggestions');
}

/**
 * initialize the events associated with address fields
 * that check if the address needs to be reverified
*/
function initEnterAddressVerificationEvents() {
    // check for changes on these fields
    // if there are, then the address verification modal should be shown
    var addressFormFields = '#shippingAddressOneLoqate, #shippingAddressTwo, #shippingAddressCity, #shippingState, #shippingZipCode, #addressaddress2, #addresscity, #addressstateCode, #addresspostalCode, #shippingAddressCityText, #shippingAddressOne, #shippingStateText';
    $(document).on('change', addressFormFields, function () {
        var changed = checkForShippingsAddressChanges($(addressFormFields));
        updateNeedsVerification(changed);
    });
}

module.exports = {
    removeHashFromAddress: removeHashFromAddress,
    generateAddressSuggestionList: generateAddressSuggestionList,
    initEnterManualAddressEvents: initEnterManualAddressEvents,
    isLoqateContainer: isLoqateContainer,
    isContainerMode: isContainerMode,
    isDropdownMenuOpen: isDropdownMenuOpen,
    initEnterAddressVerificationEvents: initEnterAddressVerificationEvents,
    removeAddressSuggestions: removeAddressSuggestions,
    updateNeedsVerification: updateNeedsVerification,
    showAdditionalAddressFields: showAdditionalAddressFields,
    handleManualAddress: handleManualAddress
};
